import React, { useContext } from 'react';
import * as S from './styled';
import AppContext from '../../context/AppContext';
import Icon from '../Icon';
import Share from '../Share';

const Header = ({ icon }) => {
  const { headerConfig: config = {} } = useContext(AppContext);

  return (
    <S.HeaderContainer data-blocoid="Bloco: Header">
      <Share />
      <S.TitleHeader hideMobile={config.hideMobileTitle}>
        Cap Ganhador
      </S.TitleHeader>
      <Icon icon={icon} className="logo" />
    </S.HeaderContainer>
  );
};

export default Header;
